import LoginEmail from '../../auth/components/email/LoginEmail';

export default function EmailSignInPage() {
    return <LoginEmail />;
}
